import { createFileRoute, Outlet } from '@tanstack/react-router'
import { profilesListSearchSchema } from '@/features/profiles/profile-list-search'

/** Search lives on the layout so list filters survive navigation to `/profiles/$uuid`. */
export const Route = createFileRoute('/_authed/profiles')({
  validateSearch: profilesListSearchSchema,
  component: () => <Outlet />,
})
